import type {} from '@mui/x-date-pickers/themeAugmentation'
import { Components, Theme } from '@mui/material/styles'

export const inputBaseTheme: Components<Theme>['MuiInputBase'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.primary,
    }),
    input: ({ theme }) => ({
      '&::placeholder': {
        color: theme.palette.text.secondary,
        opacity: 1,
      },
    }),
  },
}

export const inputTheme: Components<Theme>['MuiInput'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&:before': {
        borderBottomColor: theme.palette.divider,
      },
      '&:hover:not(.Mui-disabled):before': {
        borderBottomColor: theme.palette.text.secondary,
      },
      '&.Mui-focused:after': {
        borderBottomColor: theme.palette.primary.main,
      },
    }),
  },
}

export const outlinedInputTheme: Components<Theme>['MuiOutlinedInput'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.background.paper,
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.text.secondary,
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.primary.main,
      },
    }),
    notchedOutline: ({ theme }) => ({
      borderColor: theme.palette.divider,
    }),
  },
}

export const pickersOutlinedInputTheme: Components<Theme>['MuiPickersOutlinedInput'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.background.paper,
    }),
  },
}

export const inputLabelTheme: Components<Theme>['MuiInputLabel'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.secondary,
      '&.Mui-focused': {
        color: theme.palette.primary.main,
      },
    }),
  },
}

export const formHelperTextTheme: Components<Theme>['MuiFormHelperText'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.secondary,
      '&.Mui-error': {
        color: theme.palette.error.main,
      },
    }),
  },
}

export const skeletonTheme: Components<Theme>['MuiSkeleton'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.11)' : theme.palette.action.hover,
    }),
  },
}
